import React, { useState, useEffect, useRef } from 'react';  
import { useParams, Link } from 'react-router-dom';  
import styled from 'styled-components';  
import Loading from '../components/Loading_robo'; // ここで新しいコンポーネントをインポート  
import { API_URL } from './api'; // api.js からインポート  
  
const Container = styled.div`  
  display: flex;  
  flex-direction: column;  
  align-items: center;  /* 横の中央に配置 */  
  padding: 20px;  
  // background: linear-gradient(to right, #006331, #B2D7C5);  
  min-height: 100vh;  
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;  
  color: green;  
`;  
  
const StyledImage = styled.img`  
  border-radius: 8px;  
  width: 100%;  
  max-width: 600px;  
  height: auto;  
`;  
  
const BoldLink = styled(Link)`  
  color: black;  
  text-decoration: none;  
  font-weight: bold;  
  display: inline-block;  
`;  
  
const ImageDisplay = () => {  
  const [imageSrc, setImageSrc] = useState('');  
  const [loading, setLoading] = useState(true); // ロード状態を管理するステートを追加  
  const latestSeqNum = useRef(0);  
  const { id } = useParams();  
  const imageHubName = `video_hub_${id}`;  
  const commandHubName = `command_hub_${id}`;  
  const forced_agristInterval = useRef(null);  
  const websocketRef = useRef(null);  
  
  useEffect(() => {  
    let cleanupWebSocket;  
    let timeoutId;  
  
    const fetchDataAndInitializeWebSocket = async () => {  
      const response = await fetch(`${API_URL}/getToken?hubName=${imageHubName}`, {  
        method: 'GET',  
        headers: { 'Content-Type': 'application/json' },  
      });  
      const data = await response.json();  
  
      if (!websocketRef.current) {  
        websocketRef.current = new WebSocket(data.url);  
        websocketRef.current.binaryType = 'arraybuffer';  
        console.log("WebSocket created");  
      } else {  
        console.log("WebSocket reused");  
      }  
  
      websocketRef.current.onmessage = (event) => {  
        const uint8Data = new Uint8Array(event.data);  
        const seqNum = uint8Data.slice(0, 4).reduce((acc, val, i) => acc + val * Math.pow(256, i), 0);  
        const imageBytes = uint8Data.slice(4);  
        const imageBase64 = btoa(  
          new Uint8Array(imageBytes).reduce(  
            (data, byte) => data + String.fromCharCode(byte),  
            '',  
          )  
        );  
  
        if (seqNum > latestSeqNum.current) {  
          setImageSrc(`data:image/jpeg;base64,${imageBase64}`);  
          latestSeqNum.current = seqNum;  
          setLoading(false); // 画像がロードされたらロード状態を解除  
        }  
      };  
  
      websocketRef.current.onclose = () => {  
        console.log("WebSocket closed on client");  
      };  
  
      cleanupWebSocket = () => {  
        if (websocketRef.current) {  
          websocketRef.current.close();  
          console.log("WebSocket closed");  
        }  
      };  
    };  
  
    fetchDataAndInitializeWebSocket();  
  
    timeoutId = setTimeout(() => {  
      if (websocketRef.current) {  
        websocketRef.current.close();  
        console.log("WebSocket closed after 10 minute");  
      }  
    }, 600 * 1000);  
  
    return () => {  
      if (cleanupWebSocket) {  
        cleanupWebSocket();  
      }  
      clearTimeout(timeoutId);  
    };  
  }, [imageHubName]);  
  
  useEffect(() => {  
    forced_agristInterval.current = setInterval(() => {  
      fetch(`${API_URL}/forced_agrist`, {  
        method: 'POST',  
        headers: { 'Content-Type': 'application/json' },  
        body: JSON.stringify({ hubName: commandHubName }),  
      });  
    }, 1000);  
  
    return () => {  
      clearInterval(forced_agristInterval.current);  
    };  
  }, [commandHubName]);  
  
  if (loading) {  
    return <Loading />; // ロード中はLoadingコンポーネントを表示  
  }  
  
  return (  
    <Container>  
      <h1>リアルタイム映像</h1>  
      <p>{id}</p>  
      <StyledImage key={id} src={imageSrc} alt={`Loading... ${id}`} />  
      <p>10分後に切断します</p>  
      <BoldLink to={`/${id}`}>前に戻る</BoldLink>  
    </Container>  
  );  
};  
  
export default ImageDisplay;  
